import Vue from 'vue';

import storeService from '@/services/store';

import { bridge, module, moduleName } from './store';

storeService.registerModule(moduleName, module);
// Vue.nextTick(() => {
//     bridge.loadInitial();
// });